(function() {

  // set dynamic width for the blog tag filter select element...
    const select = document.querySelector("#BlogTagFilter");
    if (!select) return;
    
    const span = document.createElement("span");
    document.body.appendChild(span);
    span.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap;font:" + getComputedStyle(select).font;
    
    span.textContent = select.options[select.selectedIndex].text;
    select.style.width = (span.offsetWidth + 50) + "px";
    span.remove();

  
    // add event listener to the blog tag filter select element...
    let filterBys = document.querySelectorAll('[data-blog-tag-filter]');
  
    if (!filterBys.length) return;
  
    filterBys.forEach(function(filterBy) {
      filterBy.addEventListener('change', function(evt) {
        location.href = evt.target.value;
      });
    });
})();